import { render, staticRenderFns } from "./invalidate-document-modal.vue?vue&type=template&id=5775d0d5&scoped=true&"
import script from "./invalidate-document-modal.vue?vue&type=script&lang=js&"
export * from "./invalidate-document-modal.vue?vue&type=script&lang=js&"
import style0 from "./invalidate-document-modal.vue?vue&type=style&index=0&id=5775d0d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775d0d5",
  null
  
)

component.options.__file = "invalidate-document-modal.vue"
export default component.exports